import {
  PaginatedResponse,
  PayPerLeadCountiesFilter,
  PayPerLeadFilter,
  PayPerLeadStatisticsFilter,
  PayPerLeadSubscriptionFilter,
  ResponseError,
} from "@shared/interfaces";
import { PayPerLead, PayPerLeadWithDetail, PayPerLeadDispute, LeadSessionTracking } from "@shared/models/PayPerLead";
import { Account, County, State } from "@shared/models";
import { PayPerLeadBuyerProfile } from "@containers/PayPerLead/interface/PayPerLeadBuyerProfile";

import {
  PayPerLeadPurchaseInfo,
  PayPerLeadStatistics,
  PayPerLeadSubscription,
  PayPerLeadSubscriptionStatistics,
  PayPerLeadSubscriptionWithCustomer,
} from "./PayPerLeadSubscription";
import { LeadPriceByCounty, LeadPriceByState, StatesById } from "./Actions";

export enum PayPerLeadsError {
  getPayPerLeadError = "getPayPerLeadError",
  getPayPerLeadsError = "getPayPerLeadsError",
  getPayPerLeadsOrderError = "getPayPerLeadsOrderError",
  setSubscriptionDiscountError = "setSubscriptionDiscountError",
  getPayPerCurrentMonthLeadsError = "getPayPerCurrentMonthLeadsError",
  disputePayPerLeadError = "disputePayPerLeadError",
  getPayPerLeadCustomersError = "getPayPerLeadCustomersError",
  getPayPerLeadStatisticsError = "getPayPerLeadStatisticsError",
  getPayPerLeadsCountiesError = "getPayPerLeadsCountiesError",
  getPayPerLeadsSubscriptionsError = "getPayPerLeadsSubscriptionsError",
}

export interface PayPerLeadCountyHistory {
  id: number;
  price: number;
  old_price: number;
  limit: number;
  old_limit: number;
  immediately: number;
  created_at: Date;
  created_by: string;
  applied_at?: Date;
  applied_by?: string;
}

export interface PayPerLeadCountyPrice {
  price: number;
  limit?: number;
}

export interface PayPerLeadCounty extends County {
  state: State;
  price: PayPerLeadCountyPrice;
  history: PayPerLeadCountyHistory[];
  ordered: number;
  generated: number;
  active: boolean;
}

export interface PayPerLeadStateType {
  lead: PayPerLeadWithDetail | null;
  leads: PaginatedResponse<PayPerLeadWithDetail & LeadSessionTracking> | null;
  selectedLeadIds: number[];
  currentMonthLeads: PaginatedResponse<PayPerLead> | null;
  filter: PayPerLeadFilter;
  filterOptions?: LeadFilterOptions;
  statisticsFilter: PayPerLeadStatisticsFilter;
  subscriptionFilter: PayPerLeadSubscriptionFilter;
  subscriptions: PayPerLeadSubscription[] | null;
  subscriptionsList: PayPerLeadSubscription[] | null;
  subscriptionsTotalCount: number;
  subscription: PayPerLeadSubscription;
  errors: {
    [key in PayPerLeadsError]: ResponseError | null;
  };
  disputes: PaginatedResponse<PayPerLeadDispute> | null;
  customers: PaginatedResponse<PayPerLeadSubscriptionWithCustomer> | null;
  cache: PayPerLeadCacheType;
  statistics: PayPerLeadStatistics | null;
  purchaseInfo: PayPerLeadPurchaseInfo | null;
  subscriptionStatistics: PayPerLeadSubscriptionStatistics | null;
  selectedCountiesIds: number[];
  counties: PaginatedResponse<PayPerLeadCounty> | null;
  countiesFilter: PayPerLeadCountiesFilter;
  buyerProfile?: PayPerLeadBuyerProfile | null;
}

export interface LeadFilterOptions {
  states: number[];
  counties: number[];
  dates?: string[];
  customers?: Account[];
}

export interface PayPerLeadCacheType {
  leadPricesByCounty: LeadPriceByCounty;
  leadPriceByState: LeadPriceByState;
  stateOptions: StatesById;
}
